<template lang="pug">
  .settings
    v-container(style="max-width:600px")
      p.title.my-2 Payment Method
      
    //- .modals
      update-company-details(v-if="showUpdateCompanyDetails" :open.sync="showUpdateCompanyDetails" :company.sync="latestCompany")
      delivery-charge-list(v-if="showUpdateDeliveryChargeDialog" :open.sync="showUpdateDeliveryChargeDialog" :company="company" @activated="fetchShippingSettings")
      update-trackers(v-if="showUpdateTrackersDialog" :open.sync="showUpdateTrackersDialog" :company.sync="company" :type="openTrackerType")
      delete-company(v-if="deleteCompanyDialog" :open.sync="deleteCompanyDialog" :company="company")

</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'PaymentMethod',
  components: { },
  props: ['company'],
  data: () =>  ({

  }),
  mounted () {
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
  }
}
</script>

<style lang="scss" scoped>

</style>

<i18n>
{}
</i18n>
